import React, {useEffect} from 'react';
import IconWhatsApp from 'components/WhatsAppSupportButton/icons';
import WhatsAppSupportLink, {
  ChatStacking,
  FLOATING_STACK_BOTTOM
} from 'components/WhatsAppSupportButton/styles';
import useChatPlacement from 'components/WhatsAppSupportButton/useChatPlacement';
import useIsModalOpen from 'components/WhatsAppSupportButton/useIsModalOpen';

const WHATSAPP_URL =
  'https://wa.me/18884771537?text=Hi%20Sauce%20team%2C%20I%20need%20your%20help%20with';

const STACK_VARIABLE = '--floating-stack-bottom';

// Shown to every location (GROW-2642); it used to be behind the
// whatsapp_support_cta service feature.
const WhatsAppSupportButton = () => {
  const mode = useChatPlacement();
  const isModalOpen = useIsModalOpen();

  useEffect(() => {
    if (mode !== 'above' || isModalOpen) return undefined;
    document.body.style.setProperty(STACK_VARIABLE, FLOATING_STACK_BOTTOM);
    return () => document.body.style.removeProperty(STACK_VARIABLE);
  }, [mode, isModalOpen]);

  if (isModalOpen) return <ChatStacking $hideChat />;

  return (
    <>
      <ChatStacking />
      {mode !== 'hidden' && (
        <WhatsAppSupportLink
          $mode={mode}
          href={WHATSAPP_URL}
          target='_blank'
          rel='noopener noreferrer'
          aria-label='Message us on WhatsApp'
          data-testid='whatsapp-support-button'
        >
          <IconWhatsApp />
        </WhatsAppSupportLink>
      )}
    </>
  );
};

export default WhatsAppSupportButton;
